/**
 * Environment access wrapper. All env reads flow through here so config is not
 * scattered. Secrets never live in the frontend — only the public backend URL.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!BACKEND_URL) {
  // Fail loudly in development; never silently fall back to a hard-coded URL.
  console.error("[env] REACT_APP_BACKEND_URL is not set.");
}

export const ENV = {
  backendUrl: BACKEND_URL,
  apiBase: `${BACKEND_URL}/api`,
  isProduction: process.env.NODE_ENV === "production",
};
